/**
 * Google Analytics 4 event tracking helper.
 * No-ops when gtag is not loaded (e.g. MeasurementId not configured).
 */
export function trackEvent(eventName, eventParams = {}) {
  if (typeof window === 'undefined' || !window.gtag) return;
  try {
    window.gtag('event', eventName, eventParams);
  } catch {
    // ignore
  }
}

export function trackPageView(pagePath, pageTitle) {
  if (typeof window === 'undefined' || !window.gtag) return;
  try {
    window.gtag('event', 'page_view', {
      page_path: pagePath,
      page_title: pageTitle,
    });
  } catch {
    // ignore
  }
}
